/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Details about storage at the source.
*/
export class SourceStorage {
  /**
  * Total storage size at the source, in bytes.
  */
  'sizeBytes'?: number;
  /**
  * The source storage volumes of the inventory item
  */
  'volumeCount'?: number;
  /**
  * The source storage files of the inventory item
  */
  'filesCount'?: number;
  /**
  * Number of objects in the source storage. Applicable for object storage resources, such as S3 or GCS. 
  */
  'objectCount'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "volumeCount",
      "baseName": "volumeCount",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "filesCount",
      "baseName": "filesCount",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "objectCount",
      "baseName": "objectCount",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return SourceStorage.attributeTypeMap;
  }

  public constructor() {
  }
}

